export default {
  "en": {
    "landingTitle": "How would you like to communicate?",
    "voiceCall": "Voice Call",
    "textChat": "Text Chat",
    "clickToStartCall": "Click to Start Call",
    "realTimeVoice": "Real-time voice conversation",
    "startCall": "Start Call",
    "listening": "Listening...",
    "speakFreely": "Speak freely",
    "liveTranscript": "Live Transcript",
    "transcriptWillAppear": "Transcript will appear here during the call...",
    "mute": "Mute",
    "speaker": "Speaker",
    "endCall": "End Call",
    "hello": "Hello! How can I help?",
    "sendMessage": "Send a message to get started",
    "online": "Online",
    "newChat": "New Chat",
    "back": "Back",
    "close": "Close",
    "error": "Error",
    "typeMessage": "Type your message...",
    "sendMessageAria": "Send message",
    "domainNotValidated": "Domain not validated",
    "domainErrorMessage": "This domain is not whitelisted. Please contact the administrator to whitelist your website URL."
  },
  "he": {
    "landingTitle": "איך תרצה לתקשר?",
    "voiceCall": "שיחה קולית",
    "textChat": "צ'אט טקסט",
    "clickToStartCall": "לחץ להתחלת שיחה",
    "realTimeVoice": "שיחה קולית בזמן אמת",
    "startCall": "התחל שיחה",
    "listening": "מקשיב...",
    "speakFreely": "דבר בחופשיות",
    "liveTranscript": "תמלול בזמן אמת",
    "transcriptWillAppear": "התמלול יופיע כאן במהלך השיחה...",
    "mute": "השתק",
    "speaker": "רמקול",
    "endCall": "סיים שיחה",
    "hello": "שלום! איך אפשר לעזור?",
    "sendMessage": "שלח הודעה או עבור למצב קולי לשיחה בזמן אמת",
    "online": "מקוון",
    "newChat": "צ'אט חדש",
    "back": "חזור",
    "close": "סגור",
    "error": "שגיאה",
    "typeMessage": "הקלד הודעה...",
    "sendMessageAria": "שלח הודעה",
    "domainNotValidated": "דומיין לא מאומת",
    "domainErrorMessage": "דומיין זה לא ברשימת המורשים. אנא פנה למנהל המערכת כדי להוסיף את כתובת האתר שלך לרשימה."
  },
  "ar": {
    "landingTitle": "كيف تريد التواصل؟",
    "voiceCall": "مكالمة صوتية",
    "textChat": "دردشة نصية",
    "clickToStartCall": "انقر لبدء المكالمة",
    "realTimeVoice": "محادثة صوتية في الوقت الفعلي",
    "startCall": "ابدأ المكالمة",
    "listening": "الاستماع...",
    "speakFreely": "تكلم بحرية",
    "liveTranscript": "نص مباشر",
    "transcriptWillAppear": "سيظهر النص هنا أثناء المكالمة...",
    "mute": "كتم الصوت",
    "speaker": "مكبر الصوت",
    "endCall": "إنهاء المكالمة",
    "hello": "مرحبا! كيف يمكنني المساعدة؟",
    "sendMessage": "أرسل رسالة للبدء",
    "online": "متصل",
    "newChat": "محادثة جديدة",
    "back": "رجوع",
    "close": "إغلاق",
    "error": "خطأ",
    "typeMessage": "اكتب رسالة...",
    "sendMessageAria": "إرسال رسالة",
    "domainNotValidated": "النطاق غير معتمد",
    "domainErrorMessage": "هذا النطاق غير مسموح به. يرجى الاتصال بالمسؤول لإضافة عنوان موقع الويب الخاص بك إلى القائمة."
  },
  "ru": {
    "landingTitle": "Как вы хотите общаться?",
    "voiceCall": "Голосовой звонок",
    "textChat": "Текстовый чат",
    "clickToStartCall": "Нажмите, чтобы начать звонок",
    "realTimeVoice": "Голосовой разговор в реальном времени",
    "startCall": "Начать звонок",
    "listening": "Слушаю...",
    "speakFreely": "Говорите свободно",
    "liveTranscript": "Живая транскрипция",
    "transcriptWillAppear": "Транскрипция появится здесь во время звонка...",
    "mute": "Отключить звук",
    "speaker": "Динамик",
    "endCall": "Завершить звонок",
    "hello": "Привет! Как я могу помочь?",
    "sendMessage": "Отправьте сообщение для начала",
    "online": "В сети",
    "newChat": "Новый чат",
    "back": "Назад",
    "close": "Закрыть",
    "error": "Ошибка",
    "typeMessage": "Введите сообщение...",
    "sendMessageAria": "Отправить сообщение",
    "domainNotValidated": "Домен не проверен",
    "domainErrorMessage": "Этот домен не в белом списке. Пожалуйста, свяжитесь с администратором, чтобы добавить URL вашего веб-сайта в список."
  },
  "es": {
    "landingTitle": "¿Cómo te gustaría comunicarte?",
    "voiceCall": "Llamada de voz",
    "textChat": "Chat de texto",
    "clickToStartCall": "Haz clic para iniciar la llamada",
    "realTimeVoice": "Conversación de voz en tiempo real",
    "startCall": "Iniciar llamada",
    "listening": "Escuchando...",
    "speakFreely": "Habla libremente",
    "liveTranscript": "Transcripción en vivo",
    "transcriptWillAppear": "La transcripción aparecerá aquí durante la llamada...",
    "mute": "Silenciar",
    "speaker": "Altavoz",
    "endCall": "Terminar llamada",
    "hello": "¡Hola! ¿Cómo puedo ayudarte?",
    "sendMessage": "Envía un mensaje para comenzar",
    "online": "En línea",
    "newChat": "Nuevo chat",
    "back": "Atrás",
    "close": "Cerrar",
    "error": "Error",
    "typeMessage": "Escribe un mensaje...",
    "sendMessageAria": "Enviar mensaje",
    "domainNotValidated": "Dominio no validado",
    "domainErrorMessage": "Este dominio no está en la lista blanca. Por favor, contacte al administrador para agregar la URL de su sitio web a la lista."
  },
  "fr": {
    "landingTitle": "Comment souhaitez-vous communiquer?",
    "voiceCall": "Appel vocal",
    "textChat": "Chat texte",
    "clickToStartCall": "Cliquez pour démarrer l'appel",
    "realTimeVoice": "Conversation vocale en temps réel",
    "startCall": "Démarrer l'appel",
    "listening": "Écoute...",
    "speakFreely": "Parlez librement",
    "liveTranscript": "Transcripción en direct",
    "transcriptWillAppear": "La transcription apparaîtra ici pendant l'appel...",
    "mute": "Muet",
    "speaker": "Haut-parleur",
    "endCall": "Terminer l'appel",
    "hello": "Bonjour! Comment puis-je vous aider?",
    "sendMessage": "Envoyez un message pour commencer",
    "online": "En ligne",
    "newChat": "Nouveau chat",
    "back": "Retour",
    "close": "Fermer",
    "error": "Erreur",
    "typeMessage": "Tapez votre message...",
    "sendMessageAria": "Envoyer un message",
    "domainNotValidated": "Domaine non validé",
    "domainErrorMessage": "Ce domaine n'est pas sur la liste blanche. Veuillez contacter l'administrateur pour ajouter l'URL de votre site Web à la liste."
  },
  "de": {
    "landingTitle": "Wie möchten Sie kommunizieren?",
    "voiceCall": "Sprachanruf",
    "textChat": "Text-Chat",
    "clickToStartCall": "Klicken Sie, um den Anruf zu starten",
    "realTimeVoice": "Sprachanruf in Echtzeit",
    "startCall": "Anruf starten",
    "listening": "Hören...",
    "speakFreely": "Sprechen Sie frei",
    "liveTranscript": "Live-Transkription",
    "transcriptWillAppear": "Die Transkription erscheint hier während des Anrufs...",
    "mute": "Stumm",
    "speaker": "Lautsprecher",
    "endCall": "Anruf beenden",
    "hello": "Hallo! Wie kann ich helfen?",
    "sendMessage": "Senden Sie eine Nachricht zum Starten",
    "online": "Online",
    "newChat": "Neuer Chat",
    "back": "Zurück",
    "close": "Schließen",
    "error": "Fehler",
    "typeMessage": "Geben Sie eine Nachricht ein...",
    "sendMessageAria": "Nachricht senden",
    "domainNotValidated": "Domain nicht validiert",
    "domainErrorMessage": "Diese Domain steht nicht auf der Whitelist. Bitte kontaktieren Sie den Administrator, um die URL Ihrer Website zur Liste hinzuzufügen."
  }
};
